import { done, forward } from 'assets/icons';
import NotFound from 'common/NotFound';
import useDebounce from 'common/UseDebounce';
import useFullPageLoader from 'common/UseFullPageLoader';
import { SearchBar } from 'components/form';
import React, { useEffect, useState } from 'react'
import { BiSupport } from 'react-icons/bi';
import Pagination from 'react-js-pagination';
import { useSearchParams } from 'react-router-dom';
import { supportListApi } from 'services/support';
import { dateFormat } from 'utils/dateFormat';
import findSerialNumber from 'utils/findSerialNumber';
import ReadMore from 'utils/readMoreModal/ReadMore';
import UpdateSupportStatus from './UpdateSupportStatus';
import { RxCross2 } from "react-icons/rx";
import { isHighlighted, markRowOpened, subscribeSeen, supportSeenId } from 'utils/seenNotifications';

const SupportList = () => {
    const [searchParams, setSearchParams] = useSearchParams();
    const [loader, onShow, onHide] = useFullPageLoader();
    const activePage = +searchParams.get("page") || 1;
    const search = searchParams.get("search") || ''
    const debouncedValue = useDebounce(search, 300);
    const [total, setTotal] = useState(null);
    const [support, setSupport] = useState([]);
    const [readMoreData, setReadMoreData] = useState({ modal: false })
    const [changeStatus, setChangeStatus] = useState({ modal: false })
    // bumped whenever the shared "seen" set changes so highlights re-render live
    const [, setSeenTick] = useState(0);
    // bumped by an incoming support notification to force a fresh list fetch
    const [notifTick, setNotifTick] = useState(0);
    // console.log('support', support)

    // keep row highlights in sync with the global notification "seen" store
    useEffect(() => {
        return subscribeSeen(() => setSeenTick((n) => n + 1));
    }, [])

    // when a NEW support notification arrives, jump to the newest page and
    // refetch so the just-raised (highlighted) ticket appears in the list
    useEffect(() => {
        const onNotif = (e) => {
            const kind = `${e?.detail?.type || ''} ${e?.detail?.title || ''}`.toLowerCase();
            if (!kind.includes('support') && !kind.includes('query') && !kind.includes('ticket')) return;
            const params = new URLSearchParams(searchParams);
            params.delete('search');
            params.delete('page'); // back to page 1 (newest first)
            setSearchParams(params);
            setNotifTick((n) => n + 1); // force refetch even if already on page 1
        };
        window.addEventListener('notification:new', onNotif);
        return () => window.removeEventListener('notification:new', onNotif);
    }, [searchParams, setSearchParams])

    // highlight ONLY the ticket whose notification the admin clicked (its id was
    // flagged via markHighlight in DashboardHeader); opening the row once clears
    // the highlight (see handleOpenRow → markRowOpened).
    const isRowNew = (data) =>
        data?.status === 'PENDING' &&
        isHighlighted(supportSeenId(data?._id));

    // opening a row (viewing / handling it) clears its highlight
    const handleOpenRow = (data) => {
        if (data?._id) markRowOpened(supportSeenId(data._id));
    };
    //-----------Handel Pagination-----------
    const handlePageChange = (event) => {
        searchParams.set("page", event);
        setSearchParams(searchParams);
    };
    // ----------handle-search-------------
    const handleSearch = (e) => {
        const newParams = new URLSearchParams(searchParams);
        newParams.set("search", e.target.value);
        newParams.set("page", 1);
        setSearchParams(newParams);
    }
    // -----------read-more-modal-------------
    const handleReadMore = (data) => {
        setReadMoreData({ description: data, modal: true, title: 'Message' })
    }
    // -----------handle-Status-------------
    const handleStatus = (data) => {
        handleOpenRow(data)
        setChangeStatus({ ...data, modal: true })
    }
    // ----------listing-API-------------
    const fetchSupportList = async () => {
        try {
            onShow();
            setSupport([])
            const query = {
                ...(debouncedValue && { search: debouncedValue }),
                page: activePage,
                limit: 10,
            };
            const res = await supportListApi(query);
            const { data, code } = res?.data;
            if (code === 200) {
                setSupport(data?.data || []);
                setTotal(data?.total || 0);
            }
        }
        catch (error) {
            console.log("Data fetch error:---> ", error);
        } finally {
            onHide();
        }
    };
    useEffect(() => {
        fetchSupportList()
    }, [debouncedValue, activePage, notifTick])

    // TEMP: verify the notification id actually matches a row's _id
    useEffect(() => {
        if (!support?.length) return;
        const highlightStore = JSON.parse(localStorage.getItem('highlight_notifications') || '[]');
        const matched = support.filter((d) => isHighlighted(supportSeenId(d?._id))).map((d) => d._id);
        console.log('[support-highlight] row _ids:', support.map((d) => d?._id));
        console.log('[support-highlight] highlight store:', highlightStore);
        console.log('[support-highlight] matched rows:', matched);
    }, [support])
    useEffect(() => {
        if (!search) {
            searchParams.delete('search')
        }
        if (activePage === 1) {
            searchParams.delete('page')
        }
        setSearchParams(searchParams)
    }, [debouncedValue, activePage])
    return (
        <>
            <div className="page_title has_child">
                {/* <h3>Help Support</h3> */}
                                <h3>Customer Support Request Details</h3>


            </div>

            {/* ----------tabs related data */}
            <div className="card">
                {loader}
                {/* <div className="search-add-cat has_child">
                    <div className="search_wrapper w-25">
                        <SearchBar
                            placeholder={"Search..."}
                            onChange={handleSearch}
                            value={search}
                        />
                    </div>
                </div> */}
                <div className="table_wrap">
                    <table className="table custom_table">
                        <thead>
                            <tr>
                                {/* <th className="nowrap text-center">S.No</th> */}
                                <th className="nowrap text-center">User Name</th>
                                <th className="nowrap text-center">Reported on</th>
                                <th className="nowrap text-center">Mobile Number</th>
                                <th className="nowrap text-center">Message</th>
                                <th className="nowrap text-center">Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {support && support.length ? (
                                support?.map((data, index) => {
                                    const status = data?.status
                                    const message = status === 'REJECTED' ? data?.rejectionReason : data?.message
                                    // console.log(data?.image);
                                    const highlight = isRowNew(data);
                                    return (
                                        <tr
                                            key={index}
                                            className={highlight ? 'highlight_row' : undefined}
                                        >
                                            {/* <td className="nowrap text-center">
                                                {findSerialNumber(index, activePage, 10)}
                                            </td> */}

                                            <td className="nowrap text-center">
                                                {data?.user?.fullName || "N/A"}
                                            </td>
                                            <td className="nowrap text-center">
                                                {dateFormat(data?.createdAt) || "N/A"}
                                            </td>
                                            <td className="nowrap text-center">
                                                {data?.user?.phone || "N/A"}
                                            </td>
                                            <td className="nowrap text-center">
                                                {message.length > 15
                                                    ? <>
                                                        {message.slice(0, 15)}...
                                                        <span
                                                            onClick={() => handleReadMore(message)}
                                                            style={{ color: "blue", cursor: "pointer" }}
                                                        >
                                                            Read More
                                                        </span>
                                                    </>
                                                    : message || "N/A"
                                                }
                                            </td>
                                            <td className="nowrap text-center">
                                                {status === "RESOLVED" &&
                                                    <div className="table_button_wrap">
                                                        <img src={done} alt="" className='me-3' />
                                                        {/* <button
                                                            type="button"
                                                            className='btn btn-success'
                                                        // onClick={() => handleAddCategory(data)}
                                                        >
                                                            Resolved
                                                        </button> */}

                                                        <button
    type="button"
    className="btn"
    style={{
        backgroundColor: "#774da9",
        borderColor: "#774da9",
        color: "#fff"
    }}
>
    Resolved
</button>



                             </div>
                                                }
                                                {status === 'PENDING' &&
                                                    <div className="table_button_wrap">
                                                        <img src={forward} alt="" className='me-3' />
                                                        <button
                                                            type="button"
                                                            className='btn btn-outline-info'
                                                            onClick={() => handleStatus(data)}
                                                        >
                                                            Mark As Resolved
                                                        </button>
                                                    </div>
                                                }
                                                {/* {status === "REJECTED" &&
                                                    <div className="table_button_wrap">
                                                        <RxCross2 className='me-3' style={{ color: 'red' }} />
                                                        <button
                                                            type="button"
                                                            className='btn btn-danger'
                                                        // onClick={() => handleAddCategory(data)}
                                                        >
                                                            Rejected  Processing
                                                        </button>
                                                    </div>
                                                } */}







                                                {(status === "REJECTED" || status === "PROCESSING") && (
                                                    <div className="table_button_wrap">
                                                        <RxCross2
                                                            className="me-3"
                                                            style={{ color: "#90EE90" }}
                                                        />
                                                        <button
                                                            type="button"
                                                            style={{
                                                                backgroundColor: "#198754",
                                                                borderColor: "#90EE90",
                                                                color: "#ffffff"
                                                            }}
                                                            className="btn"
                                                            onClick={() => handleStatus(data)}
                                                        >
                                                            Processing
                                                        </button>
                                                    </div>
                                                )}
                                            </td>
                                        </tr>
                                    );
                                })
                            ) : (
                                <NotFound
                                    cols={7}
                                    msg={"Support List  not found"}
                                    onHide={onHide}
                                    icon={<BiSupport />}
                                />
                            )}
                        </tbody>
                    </table>
                </div>
            </div>
            {/* ---------read-more------------------- */}
            <ReadMore
                show={readMoreData?.modal}
                close={() => setReadMoreData({ ...readMoreData, modal: false })}
                title={readMoreData?.title}
                description={readMoreData?.description}
            />
            {/* ---------change-status------------------- */}
            <UpdateSupportStatus
                show={changeStatus?.modal}
                close={() => setChangeStatus({ ...changeStatus, modal: false })}
                data={changeStatus}
                listing={fetchSupportList}
            />


            {total > 10 && (
                <div className="pagination-wrapper">
                    <div className="Pagination">
                        <Pagination
                            activePage={activePage}
                            previousLabel={"previous"}
                            nextLabel={"next"}
                            itemsCountPerPage={10}
                            totalItemsCount={total}
                            pageRangeDisplayed={5}
                            onChange={handlePageChange}
                            hideDisabled={true}
                        />
                    </div>
                </div>
            )}
        </>
    )
}

export default SupportList
